//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('consignmentLines', {
//        templateUrl: 'views/components/views/consignmentLines/consignmentLines.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'consignmentLinesService', function ($stateParams, consignmentLinesService) {
//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//            vm.model = {
//                itemsListConsigmentLines: []
//            };
            
//            async function loadConsignmentLines() {
//                vm.model.itemsListConsigmentLines = await consignmentLinesService.listConsignmentLines({
//                    argtype: argType,
//                    argvalue: argValue
//                });
//            }

//            vm.$onInit = async function () {
//                loadConsignmentLines();
//            }
//        }]
//    });
//})();
